import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsView: FunctionComponent<Props> = ({
    children,
    className = '',
    isEditingMap = false,
    testId = TEST_ID
}) => (
    <Grid
        className={`${className} ${isEditingMap ? styles.mapView : styles.detailsView}`}
        testId={testId}>
        {children}
    </Grid>
);

export default DetailsView;
